
import { DialogService } from '../../../core/components/dialog/dialog.service';
import { DocumentAssModalComponent } from '../modals/document-ass-modal/document-ass-modal.component';
import { ELABORATION_ASS_ACTIONS } from '../../models/elaboration-ass-actions';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DocumentSimilarCitations } from '../../models/document-elaboration-similar-citations';
import { Entities } from '../../models/elaboration-entities';
import { modalMetadata } from '../../models/metadata-modal';
import { DocumentManagementService } from '../../services/document-management.service';
import { ModalMetadataComponent } from './modal-metadata/modal-metadata/modal-metadata.component';
import {
  CreazionePraticaStepperComponent
} from '../../../pratica/components/wizard-creazione/components/creazione-pratica-stepper/creazione-pratica-stepper.component';
import { ElaborationDocument } from '../../models/elaboration-doc';
import { ServicesSearch } from 'src/app/search/services/search.service';
import { SearchRequest } from 'src/app/common/models/dto/search-request';
import { RoutingConfigurationUtilService } from 'src/app/core/services/routing-configuration-util.service';
import { PraticaLight } from 'src/app/common/models/pratica/pratica-light';
import { CreazionePraticaService } from 'src/app/pratica/components/wizard-creazione/services/creazione-pratica.service';
import { CreazionePraticaStoreService } from 'src/app/pratica/components/wizard-creazione/services/creazione-pratica-store.service';
import { FascicoloLight } from 'src/app/common/models/fascicolo/fascicolo-light';
import { ConfirmModal } from "../../../core/components/confirmModal/confirm-modal.component";
import { ConfirmModalComponent } from "../../../core/components/dialog/components/confirm-modal/confirm-modal.component";
import { PropertiesSettings } from "../../../core/configuration/properties-settings";
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-document-actions-card',
  templateUrl: './document-actions-card.component.html',
  styleUrls: ['./document-actions-card.component.css']
})



export class DocumentActionsCardComponent implements OnInit, OnDestroy {


  @Input() elaboration: ElaborationDocument;
  praticaAssociata: PraticaLight = null;
  fascicoloAssociato: FascicoloLight = null;
  SimilarDocumentLenght: number;
  CitationsDocumentLenght: number;
  fascicoloTemp = null;
  Metadatanumber = 0;
  Metadata: Entities[];
  MetaDataModal: modalMetadata = {
    doc_type: [],
    matter: [],
    ecli: [],
    sentence_number: 0,
    AUT_GIUDIZIARIA: [],
    court_section: 0,
    decision_date: undefined,
    publish_date: undefined,
    outcome: [],
    case_number: "",
    judge: [],
    rapporteur: [],
    principal_actor: [],
    legal_principal_actor: [],
    defendant: [],
    legal_defendant: [],
    opposed_judgement: [],
    opposed_court: [],
    IMPORTO_ECONOMICO: [],
  };

  private componentDestroyed$: Subject<void> = new Subject<void>();


  constructor(
    private dialogService: DialogService,
    private documentManagementService: DocumentManagementService,
    private searchService: ServicesSearch,
    private creazionePraticaService: CreazionePraticaService,
    private creazionePraticaStore: CreazionePraticaStoreService,
    private routingService: RoutingConfigurationUtilService
  ) {
  }


  ngOnInit() {
    this.documentManagementService.getElaborationSimilarDocuments(this.elaboration.idElaborazione).subscribe((val: DocumentSimilarCitations) => { this.SimilarDocumentLenght = val.documenti.length; });
    this.documentManagementService.getElaborationCitationsDocuments(this.elaboration.idElaborazione).subscribe((val: DocumentSimilarCitations) => { this.CitationsDocumentLenght = val.documenti.length; });
    this.documentManagementService.getElaborationEntitiesModal(this.elaboration.idElaborazione).subscribe((val) => { this.Metadata = val, this.createMetadata(); });
    this.getFascicolo(this.elaboration.idFascicolo);
    this.getFascicoloTemp();
    console.log('elaboration iniziale: ', this.elaboration);
  }

  ngOnDestroy(): void {
    this.creazionePraticaStore.deleteAll();
    this.componentDestroyed$.next();
  }


  associa() {

    if (this.fascicoloTemp.fascicoloTemp) {
      this.switchActions(ELABORATION_ASS_ACTIONS.RIPRENDI);
    }
    else {
      const ref = this.dialogService.open(DocumentAssModalComponent, {
        data: {
          style: {
            width: '60%'
          },
          title: 'Associa fascicolo'
        }
      })
      ref.afterClosed.pipe(takeUntil(this.componentDestroyed$)).subscribe((res) => {
        if (res?.closeEvent) {
          this.onExitEvent();
        } else {
          if (res && res.hasOwnProperty('action')) {
            this.switchActions(res.action, res);
            // this.getFascioloTemp();
          }
       }
      })
    }

  }

  private switchActions(action: any, res: any = null) {
    switch (action) {
      case ELABORATION_ASS_ACTIONS.CREA_PRATICA: {
        const refCrPratica = this.dialogService.open(CreazionePraticaStepperComponent, {
          data: {
            style: {width: "70%"},
            title: 'Aggiungi nuova pratica',
            idElaborazione: this.elaboration.idElaborazione
          }
        });
        refCrPratica.afterClosed.pipe(takeUntil(this.componentDestroyed$)).subscribe((data) => {
          if (data?.closeEvent) {
            this.onExitEvent();
          } else {
            if (data && data.fascicoloTempDeleted) { this.fascicoloTemp.fascicoloTemp = null }
            else { this.fascicoloTemp = data.fascicoloTemp }
            if (data && data.fascicoloCreato && data.fascicoloTempDeleted) {
              this.fascicoloAssociato = data.fascicoloCreato;
              this.praticaAssociata = this.creazionePraticaStore.getPratica();
              this.openCompletionModal();
            }
          }
        });
        break;

      }
      case ELABORATION_ASS_ACTIONS.CREA_FASCICOLO: {
        const refCrPratica = this.dialogService.open(CreazionePraticaStepperComponent, {
          data: {
            style: {width: "70%"},
            title: 'Aggiungi nuovo fascicolo',
            idElaborazione: this.elaboration.idElaborazione,
            idPratica: res.idPratica,
            tipoPratica: res.tipoPratica,
          }
        });
        refCrPratica.afterClosed.pipe(takeUntil(this.componentDestroyed$)).subscribe((data) => {
          if (data?.closeEvent) {
            this.onExitEvent();
          } else {
            if (data && data.fascicoloTempDeleted) { this.fascicoloTemp.fascicoloTemp = null }
            else { this.fascicoloTemp = data.fascicoloTemp }
            if (data && data.fascicoloCreato && data.fascicoloTempDeleted) {
              this.fascicoloAssociato = data.fascicoloCreato;
              this.praticaAssociata = this.creazionePraticaStore.getPratica();
              this.openCompletionModal();
            }
          }
        });
        break;
      }
      case ELABORATION_ASS_ACTIONS.ASSOCIA: {

        const ref = this.dialogService.open(ConfirmModalComponent, {
          data: {
            modalConfirm: {
              text: 'Sei sicuro di voler associare l\'elaborazione al fascicolo?',
              data: [],
            },
            style: {
              width: '30%',
            },
            title: 'Associazione Elaborazione',
          }
        })
        ref.afterClosed.pipe(takeUntil(this.componentDestroyed$)).subscribe((resModal) => {
          if (resModal?.closeEvent) {
            this.onExitEvent();
          } else {
            if (resModal && resModal.modalEvent) {
              this.creazionePraticaService.associaFascicolo(this.elaboration.idElaborazione, res.idFascicolo).subscribe(response => console.log(response));
              this.getFascicolo(res.idFascicolo);
            }
            this.getFascicoloTemp();
          }
        });
        break;
      }
      case ELABORATION_ASS_ACTIONS.RIPRENDI: {
        const refCrPratica = this.dialogService.open(CreazionePraticaStepperComponent, {
          data: {
            style: {width: "70%"},
            title: 'Aggiungi nuova pratica',
            idElaborazione: this.elaboration.idElaborazione,
          }
        });
        refCrPratica.afterClosed.pipe(takeUntil(this.componentDestroyed$)).subscribe((data) => {
          if (data?.closeEvent) {
            this.onExitEvent();
          } else {
            if (data && data.fascicoloTempDeleted) { this.fascicoloTemp.fascicoloTemp = null }
            else { this.fascicoloTemp = data.fascicoloTemp }
            if ( data  && data.fascicoloCreato && data.fascicoloTempDeleted ) {
              this.fascicoloAssociato = data.fascicoloCreato;
              this.praticaAssociata = this.creazionePraticaStore.getPratica();
              this.openCompletionModal();
            }
          }
        });
        break;
      }
    }
  }

  createMetadata() {
    // MAP METADATA OBJ FROM ALL METADATA
    for (const keymodal in this.MetaDataModal) {
      for (const metadata of this.Metadata) {
        if (metadata.tipoEntita.label_key === keymodal) {
          // console.log(typeof(this.MetaDataModal[keymodal]));
          if (typeof (this.MetaDataModal[keymodal]) !== 'object' && typeof (this.MetaDataModal[keymodal]) != undefined) {
            this.MetaDataModal[keymodal] = metadata.valore;
          } else {
            this.MetaDataModal[keymodal].push(metadata.valore);
          }
          this.Metadatanumber++;
        }
      }
    }
  }

  onShowMetaData() {

    const ref = this.dialogService.open(ModalMetadataComponent, {
      data: {
        style: {
          width: '70%'
        },
        metadata: this.MetaDataModal
      }
    })
  }

  getFascicolo(idFascicolo: string, afterCreate: boolean = false) {
    if (idFascicolo == null) {
      return;
    }
    let searchRequest: SearchRequest = new SearchRequest;
    searchRequest.searchCriteria.searchText = idFascicolo;
    searchRequest.includePratiche = true;

    this.searchService.search(searchRequest).subscribe(response => {
      if (response && response.pratiche && response.pratiche[0] && response.pratiche[0].fascicoliLight) {
        this.praticaAssociata = response.pratiche[0];
        this.fascicoloAssociato = response.pratiche[0].fascicoliLight.filter(fascicolo => fascicolo.id === idFascicolo)[0];
        if (afterCreate) {
          const ref = this.openCompletionModal()
        }
      }
    });
  }

  setPraticaAssociata(idFascicolo: string) {
    if (idFascicolo == null) {
      return;
    }
    let searchRequest: SearchRequest = new SearchRequest;
    searchRequest.searchCriteria.searchText = idFascicolo;
    searchRequest.includePratiche = true;

    this.searchService.search(searchRequest).subscribe(response => {
      if (response && response.pratiche && response.pratiche[0]) {
        this.praticaAssociata = response.pratiche[0];
      }
    });
  }

  openCompletionModal() {
    return this.dialogService.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: 'Completamento del fascicolo ' + this.fascicoloAssociato.intestazione.campi.posizione + ' avvenuto con successo.',
          data: [],
          hideButtons: true
        },
        style: {
          width: '30%',
        },
        title: PropertiesSettings.MSG_GENERIC_SUCCESS,
      }
    });
  }

  getFascicoloTempAssocia() {
    this.associa();
    // this.creazionePraticaService.getFascicoloTemp(this.elaboration.idElaborazione).subscribe((val) => { this.fascicoloTemp = val, this.associa();});
  }

  getFascicoloTemp() {
    this.creazionePraticaService.getFascicoloTemp(this.elaboration.idElaborazione).subscribe((val) => { console.log(val); this.fascicoloTemp = val });
  }

  getFascicoloPath(): string {
    return this.routingService.checkStatoFascicoloAndGetRoutingPath(
      this.fascicoloAssociato, this.praticaAssociata.tipoPratica.id,
      this.fascicoloAssociato.tipoFascicolo.id);
  }

  onExitEvent() { // save and update temp on click modal close
    this.creazionePraticaStore.fromWizard = false;
    console.log(this.creazionePraticaStore.buildRequest());
    console.log(this.fascicoloTemp);
    const fascicoloTempStore = this.creazionePraticaStore.buildRequest();
    if(fascicoloTempStore.fascicoloTemp.id) {
      this.fascicoloTemp = this.creazionePraticaStore.buildRequest();
    }
    this.creazionePraticaStore.deleteAll();
  }

}
